import React, { FC, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Wrapper,
  LeftSide,
  RightSide,
  StyledLoginField,
  StyledPasswordField,
  StyledButton,
} from "./styled";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { useSignIn } from "react-auth-kit";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import OutlinedInput from "@mui/material/OutlinedInput";

const url = process.env.REACT_APP_API_URL + "api/Authenticate/Login";

const Authorization: FC = () => {
  const signIn = useSignIn();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | {} | undefined>(undefined);
  const [autorizedData, setAutorizedData] = useState({
    login: "",
    password: "",
  });

  const handleLogin = (event: React.SyntheticEvent) => {
    const { value } = event.target as HTMLInputElement;
    setAutorizedData({ ...autorizedData, login: value.trim() });
  };

  const handlePassword = (event: React.SyntheticEvent) => {
    const { value } = event.target as HTMLInputElement;
    setAutorizedData({ ...autorizedData, password: value.trim() });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = async () => {
    setError(undefined);

    try {
      const response = await axios.post(url, autorizedData);

      signIn({
        token: response.data.token,
        expiresIn: 3600,
        tokenType: "JWT",
        authState: { login: autorizedData.login },
      });
      localStorage.setItem('token', response.data.token);
      navigate("/");
    } catch (err) {
      if (err && err instanceof AxiosError)
        setError(err);
      else if (err && err instanceof Error) setError(err.message);

      console.log("Error: ", err);
    }
  };

  useEffect(() => localStorage.clear(), []);

  return (
    <Wrapper>
      <LeftSide>
        <Box display="flex" flexDirection="column">
          <Typography variant="h2">Войти</Typography>
          <Typography>Введите данные для авторизации в системе</Typography>
          <StyledLoginField
            variant="outlined"
            label="Имя пользователя"
            onChange={handleLogin}
            error={Boolean(error)}
          />
          <StyledPasswordField variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Пароль
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Пароль"
              onChange={handlePassword}
              error={Boolean(error)}
            />
          </StyledPasswordField>
          {error && <Typography mt={1} color='error'>Проверьте правильность ввода имени или пароля</Typography>}
          <StyledButton variant="outlined" size="large" onClick={handleSubmit}>
            Войти
          </StyledButton>
        </Box>
      </LeftSide>
      <RightSide>
        <Typography variant="h2" mb={2}>
          {/* Кадры */}
        </Typography>
        <Typography variant="h4">Реестр</Typography>
      </RightSide>
    </Wrapper>
  );
};

export default Authorization;
